// D99 item 5: why a quotation could not be generated, in words. The server stores only a code
// (RFQ.generationError.code); this is the ONE place that code becomes prose.
export const GENERATION_ERROR_TEXT: Record<string, string> = {
  GENERATION_FAILED: 'something went wrong while building it',
  GENERATION_PRICING_UNAVAILABLE: 'prices could not be looked up',
  RFQ_NOT_FOUND: 'the request could not be found',
  RFQ_GENERATION_IN_PROGRESS: 'it is already being generated — refresh in a moment',
  RFQ_NOT_RETRYABLE: 'it is no longer in a failed state, so there is nothing to retry',
  RFQ_NOT_READY: 'the request is not ready yet',
  RFQ_HAS_NO_ITEMS: 'the request has no items',
  VAT_RATE_NOT_SET: 'the VAT rate is not set in Settings',
  FX_RATE_NOT_SET: 'the TT$/US$ rate is not set in Settings',
  // Request failures the Retry button can meet (the "Retry failed:" line).
  INTERNAL_ERROR: 'something went wrong on the server',
  // What the retry route's auth middleware sends (rbac.js / auth.js).
  PERMISSION_DENIED: 'you do not have permission to generate quotations',
  AUTH_REQUIRED: 'you are not signed in - sign in again',
  TOKEN_EXPIRED: 'your session expired - sign in again',
  TOKEN_INVALID: 'your session is not valid - sign in again',
  USER_NOT_FOUND: 'your account could not be found',
  USER_DEACTIVATED: 'your account has been deactivated',
  ROLE_DEACTIVATED: 'your role has been deactivated',
  VALIDATION_ERROR: 'the request was not valid',
};

export function generationErrorText(code?: string | null): string {
  if (!code) return '';
  return GENERATION_ERROR_TEXT[code] ?? `Unexpected error (${code})`;
}
